import { useNavigate } from "react-router-dom";
import { LEGAL } from "@/lib/legal";

const SECTIONS = [
  {
    id: "controller",
    title: "مُتحكِّم البيانات (Data Controller)",
    body: (
      <>
        <p>
          مُتحكِّم البيانات المسؤول عن هذه السياسة والمُشغِّل الرسميّ لتطبيق «{LEGAL.app_name_ar}» هو:
        </p>
        <ul className="about-list">
          <li>الاسم القانونيّ: <strong>{LEGAL.entity_ar}</strong> ({LEGAL.entity_en}).</li>
          <li>السجلّ التجاريّ: <strong>{LEGAL.cr_number}</strong>.</li>
          <li>العنوان: {LEGAL.address_ar}.</li>
          <li>
            بريد الخصوصيّة:{" "}
            <a href={`mailto:${LEGAL.privacy_email}`} className="legal-link" dir="ltr">
              {LEGAL.privacy_email}
            </a>
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "intro",
    title: "مقدّمة",
    body: (
      <>
        <p>
          نحن في {LEGAL.entity_ar} نُولي خصوصيّة مستخدمي تطبيق «{LEGAL.app_name_ar}»
          أعلى درجات الاهتمام، ونلتزم بحماية بياناتهم وفقًا للأنظمة السارية في
          {" "}{LEGAL.jurisdiction_ar} والممارسات الدوليّة المعتمدة، بما فيها اللائحة
          العامّة لحماية البيانات (GDPR) وقانون خصوصيّة المستهلك في كاليفورنيا (CCPA).
        </p>
        <p>
          باستخدامك للتطبيق فإنّك تُوافق على ما ورد في هذه السياسة. إن لم توافق
          على أيّ بندٍ منها، فيُرجى عدم استخدام التطبيق.
        </p>
      </>
    ),
  },
  {
    id: "what-we-collect",
    title: "المعلومات التي نجمعها",
    body: (
      <ul className="about-list">
        <li>
          <strong>بيانات الحساب:</strong> الاسم وعنوان البريد الإلكترونيّ وصورة
          الملف الشخصيّ — تُجمَع عبر تسجيل الدخول بحساب Google أو Apple بموافقتك الصريحة فقط.
        </li>
        <li>
          <strong>التقدُّم التعليميّ:</strong> الدروس المُكتَملة، نقاط الخبرة (XP)،
          السلسلة اليوميّة، الشارات المُكتَسَبة، والاختبارات المُجتازة.
        </li>
        <li>
          <strong>تفاعلاتك التعليميّة:</strong> النصوص التي تكتبها لتقييمها أو
          محاورة المعلّم الذكيّ — تُستخدَم لتقديم تقييمٍ فوريٍّ لك فقط، ولا تُستخدَم
          لتدريب نماذج الذكاء الاصطناعيّ.
        </li>
        <li>
          <strong>بيانات المُشتَريات:</strong> حالة اشتراكك، نوع الخطّة، تواريخ التجديد.
          <strong> لا نجمع أرقام بطاقاتك الائتمانيّة إطلاقًا</strong> — عمليّات
          الشراء تتمّ حصريًّا داخل App Store لأجهزة Apple و Google Play لأجهزة Android،
          ويقتصر ما نتلقّاه من المتجرَين على «هويّة الشراء» (Transaction ID) وحالته.
        </li>
        <li>
          <strong>بيانات فنّية أساسيّة:</strong> إصدار التطبيق، نوع نظام التشغيل،
          ومُعرِّف الجهاز الافتراضيّ لأغراض تشخيص الأعطال فقط.
        </li>
        <li>
          <strong>مُعرِّف الزائر (anonymous ID):</strong> عند استخدام التطبيق دون
          تسجيلٍ، يُخزَّن مُعرِّفٌ عشوائيٌّ محلّيًّا على جهازك لتَتَبُّع تقدُّمك.
        </li>
      </ul>
    ),
  },
  {
    id: "purpose",
    title: "الأغراض القانونيّة لجمع البيانات",
    body: (
      <ul className="about-list">
        <li>تتبُّع تقدُّمك التعليميّ وعرض إنجازاتك وشاراتك.</li>
        <li>تقديم تقييماتٍ شخصيّة بالذكاء الاصطناعيّ لكتاباتك.</li>
        <li>إدارة اشتراكك والتحقُّق من صلاحيّته مع Apple / Google.</li>
        <li>تحسين تجربة المستخدم والمحتوى التعليميّ (تحليلٌ مُجمَّعٌ ومجهول).</li>
        <li>الحفاظ على استمراريّة جلستك عبر الأجهزة عند تسجيل الدخول.</li>
        <li>الاستجابة للاستفسارات القانونيّة أو الحكوميّة المشروعة.</li>
      </ul>
    ),
  },
  {
    id: "no-sharing",
    title: "مشاركة البيانات مع أطراف ثالثة",
    body: (
      <>
        <p>
          <strong>نحن لا نبيع بياناتك، ولا نُشاركها لأغراضٍ إعلانيّة.</strong> يقتصر
          نقل البيانات إلى أطرافٍ ثالثة على الحالات الضروريّة تقنيًّا التالية:
        </p>
        <ul className="about-list">
          <li>
            <strong>Google Sign-In / Apple Sign In:</strong> للتحقُّق من هويّتك عند
            تسجيل الدخول. لا تتلقّى هاتان الخدمتان أيّ بيانات دراسيّةٍ عنك.
          </li>
          <li>
            <strong>Apple App Store / Google Play:</strong> لإدارة الاشتراكات والفوترة.
            تخضع بياناتك لدى المتجرَين لسياسة الخصوصيّة لكلٍّ منهما.
          </li>
          <li>
            <strong>مُزَوِّدو نماذج اللغة الكبيرة (LLM providers):</strong> لتشغيل
            المعلّم الذكيّ. تُرسَل رسائلك إليهم عبر قناةٍ مُشفَّرة دون تعريفك شخصيًّا،
            وتُعالَج لأغراض توليد الإجابة فقط، ولا تُستخدَم للتدريب.
          </li>
          <li>
            <strong>مُزَوِّدو البنية التحتيّة (Hosting):</strong> يُخزِّنون البيانات
            نيابةً عنّا بموجب اتفاقيّات معالجة بيانات صارمة.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "retention",
    title: "مدّة الاحتفاظ بالبيانات",
    body: (
      <ul className="about-list">
        <li>
          طالما حسابك نشط: نحتفظ ببياناتك التعليميّة لضمان استمراريّة تجربتك،
          ولمدّةٍ لا تتجاوز {LEGAL.retention_active_days} يومًا من آخر نشاطٍ لك.
        </li>
        <li>
          بعد طلب الحذف: نمحو بياناتك خلال {LEGAL.retention_deletion_days} يومًا كحدٍّ أقصى،
          باستثناء ما يُلزِمنا القانون بحفظه (سجلّات الفوترة تبقى 5 سنوات لأغراضٍ ضريبيّة).
        </li>
        <li>
          سجلّات التشخيص الفنّي المجهولة: تُحفَظ 90 يومًا كحدٍّ أقصى ثمّ تُحذَف تلقائيًّا.
        </li>
      </ul>
    ),
  },
  {
    id: "your-rights",
    title: "حقوقك",
    body: (
      <ul className="about-list">
        <li>الاطّلاع على بياناتك المُخزَّنة لدينا (حقّ الوصول).</li>
        <li>طلب تصحيح أيّ بيانٍ خاطئ (حقّ التصحيح).</li>
        <li>
          طلب حذف حسابك وبياناتك بالكامل (حقّ المحو) — يمكنك ذلك في أيّ وقت
          من داخل التطبيق: «حسابي ← حذف الحساب».
        </li>
        <li>نقل بياناتك إلى مُقدِّم خدمةٍ آخر (حقّ نقل البيانات).</li>
        <li>
          الاعتراض على معالجة بياناتك أو تقييدها (حقّ الاعتراض) — تحت GDPR /
          CCPA.
        </li>
        <li>
          تقديم شكوى إلى هيئة حماية البيانات المختصّة في بلدك إن رأيت أنّنا لم
          نلتزم بحقوقك.
        </li>
      </ul>
    ),
  },
  {
    id: "security",
    title: "الأمن التقنيّ لبياناتك",
    body: (
      <>
        <p>نتّبع إجراءاتٍ صارمة لحماية بياناتك، تشمل:</p>
        <ul className="about-list">
          <li>تشفير الاتّصالات (HTTPS/TLS 1.2+) بين التطبيق والخادم.</li>
          <li>ملفّات جلسة آمنة (HttpOnly + Secure + SameSite).</li>
          <li>وصولٍ محدود لقواعد البيانات مع تسجيلٍ دقيقٍ للعمليّات.</li>
          <li>عدم تخزين كلمات المرور (نعتمد على مصادقة Google / Apple).</li>
          <li>سياسة CORS مُحكَمة مع قائمة النطاقات المسموح بها فقط.</li>
        </ul>
      </>
    ),
  },
  {
    id: "children",
    title: "خصوصيّة القاصرين",
    body: (
      <p>
        التطبيق مُصنَّفٌ للأعمار {LEGAL.age_rating} فما فوق في متجرَي Apple و Google.
        لا نجمع عن قصدٍ بياناتٍ شخصيّة من أطفالٍ دون سنّ 13 عامًا (COPPA) أو 16
        عامًا (GDPR-K). إن اكتشفنا جمع بيانات قاصرٍ دون موافقة وليّه، سنحذفها فورًا.
        على الوليّ أن يتواصل معنا عبر بريد الخصوصيّة أعلاه لطلب الحذف الفوريّ.
      </p>
    ),
  },
  {
    id: "third-party-services",
    title: "خدمات الطرف الثالث",
    body: (
      <ul className="about-list">
        <li>Google Sign-In — <a className="legal-link" href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">Google Privacy Policy</a></li>
        <li>Sign in with Apple — <a className="legal-link" href="https://www.apple.com/legal/privacy/" target="_blank" rel="noreferrer">Apple Privacy Policy</a></li>
        <li>Apple App Store & Google Play — تخضعان لسياسة الخصوصيّة لكلٍّ منهما.</li>
      </ul>
    ),
  },
  {
    id: "changes",
    title: "تحديثات هذه السياسة",
    body: (
      <p>
        قد نُحدّث هذه السياسة من حينٍ لآخر لتعكُس تغييراتٍ في القوانين أو في
        خدماتنا. سننشُر النسخة المُحدَّثة في هذه الصفحة مع تاريخ التحديث. عند
        وجود تعديلاتٍ جوهريّة، سنُخطِرك داخل التطبيق قبل سريان التغيير.
      </p>
    ),
  },
  {
    id: "contact",
    title: "للتواصل بشأن الخصوصيّة",
    body: (
      <p>
        لأيّ استفسارٍ أو طلبٍ يتعلّق بسياسة الخصوصيّة أو ممارسة حقوقك، يُرجى
        التواصل معنا:
        <br />
        <a
          href={`mailto:${LEGAL.privacy_email}`}
          className="legal-link"
          data-testid="privacy-contact-email"
          dir="ltr"
        >
          {LEGAL.privacy_email}
        </a>
        <br />
        {LEGAL.entity_ar} — {LEGAL.address_ar} — س.ت: {LEGAL.cr_number}
      </p>
    ),
  },
];

export default function PrivacyPage() {
  const navigate = useNavigate();
  return (
    <div className="shell has-bottom-nav legal-page" data-testid="privacy-page">
      <div className="page-header legal-hero">
        <div className="legal-badge">سياسة الخصوصيّة</div>
        <h1 data-testid="privacy-title">
          سياسة <span className="gold">الخصوصيّة</span>
        </h1>
        <p>
          نشرحُ لك بوضوحٍ ما نجمعه، ولِمَ نجمعه، وكيف نحميه. شفافيّتنا معك
          جزءٌ من احترامنا لك.
        </p>
        <div className="legal-meta" data-testid="privacy-updated">
          آخر تحديث: {LEGAL.last_updated}
        </div>
      </div>

      {SECTIONS.map((s) => (
        <section
          key={s.id}
          className="about-section legal-section"
          data-testid={`privacy-section-${s.id}`}
        >
          <h2>{s.title}</h2>
          <div className="legal-body">{s.body}</div>
        </section>
      ))}

      <div className="about-cta">
        <button
          className="btn btn-primary"
          onClick={() => navigate("/")}
          data-testid="privacy-back-btn"
          style={{ padding: "12px 24px" }}
        >
          العودة إلى الرئيسيّة
        </button>
        <button
          className="btn btn-ghost"
          onClick={() => navigate("/terms")}
          data-testid="privacy-to-terms"
        >
          شروط الاستخدام
        </button>
      </div>
    </div>
  );
}
